import * as React from 'react';
import styles from './expandable-box.scss';
import { MeatballMenu } from 'ui';
import { MdExpandMore } from 'react-icons/md';
import { DropdownItem, DropdownMenuItem } from 'ui/common/dropdown-menu/dropdown-menu-item';
import { ButtonTertiary } from 'ui/common';
import { ReactNode, type JSX } from 'react';

interface ExpandableBoxComponentProps {
  title: string;
  menuItems: DropdownItem[];
  contentMessage?: React.ReactNode;
  expandedChildren?: React.ReactNode;
  children?: ReactNode;
  subTitle?: string;
  classNames?: string;
}

class ExpandableBoxComponent extends React.Component<ExpandableBoxComponentProps, {}> {

  private renderMenuItem = (menuItem: DropdownItem) => {
    return <DropdownMenuItem
      key={menuItem.value}
      menuItem={menuItem} />;
  };

  public render(): JSX.Element {
    const {
      menuItems = [],
      contentMessage,
      expandedChildren,
      children,
      subTitle,
      classNames
    } = this.props;
    const showContent = !!children || !!contentMessage;
    return (
      <div className={`${styles.expandableBox} ${classNames || ''}`}>
        <div className={`${styles.header} ${showContent ? '' : styles.hideBottomBorder}`}>
          <h3>{this.props.title}</h3>
          {subTitle && <p>{subTitle}</p>}
          <MeatballMenu closeAfterClick>
            {menuItems.map(menuItem => this.renderMenuItem(menuItem))}
          </MeatballMenu>
        </div>
        {
          showContent ? <div className={styles.content}>
            {!!contentMessage && contentMessage}
            {this.props.children}
          </div> : null
        }

        {expandedChildren && <div className={styles.expandButton}>
          <ButtonTertiary classNames="btn-block" icon={MdExpandMore} />
        </div>}
      </div>);
  }
}

export const ExpandableBox = ExpandableBoxComponent;
